import React, { useMemo } from "react";
import cn from "classnames";
import Image from "next/image";
import styles from "./styles.module.scss";

// TODO: will be renamed and substitude the old Description
const DescriptionNew = ({
  type = "row",
  collection,
  title,
  description,
  descriptionStyles = {},
  linkPath,
  linkText,
  img,
  alt,
  text = true,
  reverse = false,
  onClick = null,
  additionalInfo = false,
  aiIcon,
  aiContent,
}) => {
  const content = useMemo(() => {
    if (type === "row") {
      return (
        <div className={cn(styles.row, { reverse })}>
          <div style={descriptionStyles} className={cn(styles.item, { text })}>
            <label className={cn("title_sm", "font_bold")}>{title}</label>
            <p className={cn("text_md")}>{description}</p>
            {linkText && (
              <a
                href={linkPath}
                onClick={() => {
                  if (onClick) onClick();
                }}
              >
                {linkText}
              </a>
            )}
          </div>
          <div className={cn(styles.item, { collection: collection })}>
            {collection ? (
              collection?.map((e, i) => (
                <Image
                  src={`/images/icons/apps/${e.img}.svg`}
                  alt={alt}
                  width="82"
                  height="82"
                  key={i}
                />
              ))
            ) : (
              <>
                {typeof img === "string" && (
                  <Image
                    src={`/images/description/${img}.svg`}
                    alt={alt}
                    width="540"
                    height="540"
                  />
                )}
                {typeof img === "object" && img}
              </>
            )}
          </div>
        </div>
      );
    }
    if (type === "column") {
      return (
        <div className={cn(styles.col, { reverse })}>
          <div className={cn(styles.item, { collection: collection })}>
            {collection ? (
              collection?.map((e, i) => (
                <Image
                  src={`/images/icons/apps/${e.img}.svg`}
                  alt={alt}
                  width="82"
                  height="82"
                  key={i}
                />
              ))
            ) : (
              <>
                {typeof img === "string" && (
                  <Image
                    src={`/images/description/${img}.svg`}
                    alt={alt}
                    width="540"
                    height="540"
                  />
                )}
                {typeof img === "object" && img}
              </>
            )}
          </div>
          <div className={cn(styles.item, { text })}>
            <label className={cn("title_sm", "font_bold")}>{title}</label>
            <p className={cn("text_md")}>{description}</p>
          </div>
        </div>
      );
    }
  }, [
    type,
    reverse,
    text,
    title,
    description,
    descriptionStyles,
    linkText,
    linkPath,
    onClick,
    collection,
    img,
    alt,
  ]);

  return (
    <div className={cn(styles.description, { reverse })}>
      <div className={cn(type === "row" ? "container container_sm" : "")}>
        {content}
      </div>
      {additionalInfo && (
        <div className={styles.ai_wrapper}>
          <div className={styles.ai_container}>
            <div className={styles.ai_icon}>
              <Image
                src={`/svgs/icons/${aiIcon}.svg`}
                alt={aiIcon}
                width="24"
                height="24"
                layout="fixed"
              />
            </div>
            <div className={styles.ai_content}>{aiContent}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DescriptionNew;
